export const SOCKET_INITIALIZED = 'SOCKET/SOCKET_INITIALIZED';
export const SOCKET_SEND = 'SOCKET/SOCKET_SEND';
export const SOCKET_CLOSED = 'SOCKET/SOCKET_CLOSED';

export const INTERVENTION_UPDATE_FROM_SOCKET = 'SOCKET/INTERVENTION_UPDATE';
export const MESSAGE_RECEIVED_FROM_SOCKET = 'SOCKET/MESSAGE_SENT';
export const REACTION_REMOVED_FROM_SOCKET = 'SOCKET/MESSAGE_REACTION_REACT';
export const REACTION_RECEIVED_FROM_SOCKET = 'SOCKET/MESSAGE_REACTION_UNREACT';
